import { isObject } from '@atlassiansox/bxp-shared-utils';
import { isCSSUnits } from './css-units';
export function isPositionType(value) {
    return ['keywords', 'units'].includes(value);
}
export function isPositionHorizontalKeyword(value) {
    return ['left', 'center', 'right'].includes(value);
}
export function isPositionVerticalKeyword(value) {
    return ['top', 'center', 'bottom'].includes(value);
}
export function isPosition(value) {
    if (typeof value !== 'object' || Array.isArray(value) || value === null) {
        return false;
    }
    const temp = value;
    return (isPositionType(temp.fieldType) &&
        isObject(temp.keywords) &&
        isPositionHorizontalKeyword(temp.keywords.horizontal) &&
        isPositionVerticalKeyword(temp.keywords.vertical) &&
        isObject(temp.units) &&
        isCSSUnits(temp.units.unit) &&
        typeof temp.units.horizontal === 'number' &&
        typeof temp.units.vertical === 'number');
}
//# sourceMappingURL=position.js.map